import * as React from "react";
import PropTypes from "prop-types";
import prefixStyles from "./utils/prefixStyles";

const style = prefixStyles({
  position: "absolute",
  left: "-10000px",
  top: "auto",
  width: "1px",
  height: "1px",
  overflow: "hidden",
  flexShrink: 1,
});

const ScreenReaderOnlyLiveRegion = ({ id, children }) => (
  <div
    id={id}
    style={style}
    aria-live="assertive"
    data-component-name="ScreenReaderOnlyLiveRegion"
  >
    {children}
  </div>
);
ScreenReaderOnlyLiveRegion.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
};

export default ScreenReaderOnlyLiveRegion;



// WEBPACK FOOTER //
// ../nx-components/src/ScreenReaderOnlyLiveRegion.jsx